import React from 'react'
import Dashboard from '../../Components/Admin/Dashboard/Dashboard'

const AdminDashboardPage = () => {
  return (
    <div className='p-5'>
        <Dashboard />
    </div>
  )
}

export default AdminDashboardPage